import styled from 'styled-components';
import { ReactComponent as PlusIcon } from 'applicaiton/assets/plus.svg';
import { StyledProps } from './models';

interface ErrorProps {
  isError?: boolean;
}

export const Wrapper = styled.div<StyledProps>`
  padding: ${({ isTeleconsultationDocuments }) =>
    isTeleconsultationDocuments ? '0px' : '32px'};
  height: 100%;

  div:first-child {
    max-height: ${({ isTeleconsultationDocuments }) =>
      isTeleconsultationDocuments ? 'unset' : '280px'};
    overflow-y: ${({ isTeleconsultationDocuments }) =>
      isTeleconsultationDocuments ? 'unset' : 'auto'};
  }
`;

export const InfoText = styled.div`
  color: ${({ theme }) => theme.color.grey900};
  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
`;

export const AddDocument = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${({ theme }) => theme.color.grey500};
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;

    > label {
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border-radius: 8px;
      cursor: pointer;
    }
    > input {
      display: none;
    }

    > svg {
      margin-right: 4px;
    }
  }
`;

export const StyledPlusIcon = styled(PlusIcon)`
  display: flex;
  align-items: center;
  margin-right: 4px;
`;

export const UploadingProgress = styled.div`
  padding: 12px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.grey300};
  background: ${({ theme }) => theme.color.white};
  display: flex;
  align-items: center;
`;

export const UploadingText = styled.div<ErrorProps>`
  margin-left: 12px;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${({ theme, isError }) =>
    isError ? theme.color.error1 : theme.color.grey900};

  & p:last-child {
    font-weight: 400;
    color: ${({ theme, isError }) =>
      isError ? theme.color.error1 : theme.color.grey700};
  }
`;

export const Loader = styled.div<ErrorProps>`
  display: flex;
  width: 44px;
  height: 44px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${({ theme, isError }) =>
    isError ? theme.color.error3 : theme.color.blue100};

  svg {
    animation: ${({ isError }) =>
      isError ? 'none' : 'rotation 3s infinite linear'};
    color: ${({ theme, isError }) =>
      isError ? theme.color.error1 : theme.color.grey700};

    @keyframes rotation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(359deg);
      }
    }
  }
`;
